<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "footerPanel"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/compartida/footer.vue